import { CHALLENGER } from './tokens';

/** Pixel breakpoints for challenger funnel layout (ENG-1124). */
export const CHALLENGER_BREAKPOINTS = CHALLENGER.breakpoints;

/**
 * Emotion media queries for challenger funnel components.
 *
 * Most chrome is binary (mobile vs tablet+). Import `TABLET_UP as DESKTOP`
 * in place of the old 840px `DESKTOP` constant. Use `DESKTOP` (≥1280)
 * only when wide-desktop styles differ from tablet.
 */
export const MOBILE = CHALLENGER.media.mobile;
export const TABLET = CHALLENGER.media.tablet;
export const TABLET_UP = CHALLENGER.media.tabletUp;
export const DESKTOP = CHALLENGER.media.desktop;
